import type { RouteRecord } from "vite-react-ssg";
import { Layout } from "./components/Layout";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Solutions } from "./pages/Solutions";
import { Contact } from "./pages/Contact";
import { NotFound } from "./pages/NotFound";

export const routes: RouteRecord[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, Component: Home },
      { path: "about", Component: About },
      { path: "solutions", Component: Solutions },
      { path: "contact", Component: Contact },
      { path: "*", Component: NotFound },
    ],
  },
];
